// Selection logic for the dashboard's "File Requests" queue.
//
// A requested file is stored as a deal that is soft-deleted the moment it is
// created: the request is really a lead, and the deal exists only to give the
// Drive folder and the portal forms somewhere to live before there is a
// transaction. Soft-deleting it is what keeps the request off the Deals Board.
//
// That means this queue is the ONE place those records are meant to surface, so
// it deliberately does NOT apply the app-wide "hide soft-deleted deals" filter.
// getAlldealforAdmin does apply it, which is why the queue must be fed from
// getPendingFileRequests rather than from the general deals list.
// A Google Drive Only buyer request needs nobody's action, so it never queues (Henry, 09/25/2026).
import { isDriveOnlyRequest } from "./buyerFileFormat";
export function selectPendingFileRequests(deals) {
  return (deals || [])
    .filter(
      (d) =>
        d?.status === "Pending" &&
        d?.requestType !== "saleTurnIn" &&
        !isDriveOnlyRequest(d),
    )
    .sort((a, b) => Number(b?.createdat || 0) - Number(a?.createdat || 0));
}

